var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
      staticStyle: { "margin-bottom": "0" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "AdminNavigation" },
        },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto" }, [
            _vm.tid
              ? _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: `/#/admin/organizations/dashboard/${_vm.tid}`,
                          expression:
                            "`/#/admin/organizations/dashboard/${tid}`",
                        },
                      ],
                      staticClass: "navbar-brand",
                    },
                    [_vm._v("Dashboard")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: `/#/admin/organizations/users/active/${_vm.tid}`,
                          expression:
                            "`/#/admin/organizations/users/active/${tid}`",
                        },
                      ],
                      staticClass: "navbar-brand",
                    },
                    [_vm._v("Users")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: `/#/admin/organizations/workspaces/${_vm.tid}`,
                          expression:
                            "`/#/admin/organizations/workspaces/${tid}`",
                        },
                      ],
                      staticClass: "navbar-brand",
                    },
                    [_vm._v("Workspaces")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: `/#/sharing/admin/activeshares/${_vm.tid}`,
                          expression: "`/#/sharing/admin/activeshares/${tid}`",
                        },
                      ],
                      staticClass: "navbar-brand",
                    },
                    [_vm._v("Shares")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: `/#/admin/integrations/pipelines/dashboard/${_vm.tid}`,
                          expression:
                            "`/#/admin/integrations/pipelines/dashboard/${tid}`",
                        },
                      ],
                      staticClass: "navbar-brand",
                    },
                    [_vm._v("Integrations")]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#AdminNavigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "navbar-nav" }, [
      _c("li", { staticClass: "nav-item dropdown" }, [
        _c(
          "a",
          {
            staticClass: "nav-link dropdown-toggle",
            attrs: { "data-toggle": "dropdown" },
          },
          [_vm._v("\n                    Account\n                ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              attrs: { href: "/#/organizations/users/dashboard" },
            },
            [_vm._v("My dashboard")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              attrs: { href: "/#/organizations/users/account" },
            },
            [_vm._v("Manage your account")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-divider" }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              attrs: { href: "/organizations/sessions/close" },
            },
            [_vm._v("Sign out")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }